// --------------------- Import Globais ---------------------
import { useState, useEffect, useMemo } from "react";
import { useMediaQuery } from "@mui/material";
// --------------------- Import Antd-Design ---------------------
import {
  Col,
  Flex,
  Row,
  Button,
  MenuProps,
  Skeleton,
  Table,
  Typography,
} from "antd";
import type { TableProps } from "antd/es/table";

// --------------------- Import Material Icon ---------------------
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import HomeIcon from "@mui/icons-material/Home";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import FilterAltOffIcon from "@mui/icons-material/FilterAltOff";

// --------------------- Import Styles ---------------------
import { Container } from "../ViewGerenciarPostagens/styles";
import { usePermissao } from "../../uteis/permissaoAdm/usePermissao";
import { useBuscarIndicacoesParceiros } from "./hooks/useBuscarIndicacoesParceiros";
import { Columns } from "./components/Columns";
import ModalExcluir from "./components/ModalExcluir";
import ModalStatus from "./components/ModalStatus";
import ModalAdicionar from "./components/ModalAdicionar";

export default function ViewGerenciarIndicacoesParceiros() {
  // Traz o estilo Title da biblioteca
  const { Title } = Typography;
  const isMobile = useMediaQuery("(max-width:600px)");

  // Verificação de permissão do usuário, NDA = 0 - SEM PERMISSÃO, NDA = 1 - COM PERMISSÃO
  // Definação do Loading caso seja permitido
  const { isLoading: isTokenLoading, isValid } = usePermissao("OPE");

  const [indicacaoId, setIndicacaoId] = useState<number>();

  const [indicacaoStatus, setIndicacaoStatus] = useState<string>();

  // Controle de Paginação
  const [currentPage, setCurrentPage] = useState(1);

  const { indicacoesParceiros, isLoading, buscar } =
    useBuscarIndicacoesParceiros();

  // Inicializando o filtro
  const [filteredInfo, setFilteredInfo] = useState<{
    nomeParceiro?: string[] | null;
    nomeLeads?: string[] | null;
    celular?: string[] | null;
    status?: string[] | null;
  }>({
    nomeParceiro: null,
    nomeLeads: null,
    celular: null,
    status: null,
  });
  const [semFiltros, setSemFiltros] = useState(true);

  useEffect(() => {
    const filtros = localStorage.getItem("filtrosPropriedades");
    const pagina = localStorage.getItem("pageGerPropriedades");

    if (filtros) {
      const novoFiltro = JSON.parse(filtros);
      setFilteredInfo({
        nomeParceiro: novoFiltro.nomeParceiro
          ? [novoFiltro.nomeParceiro]
          : null,
        nomeLeads: novoFiltro.nomeLeads ? [novoFiltro.nomeLeads] : null,
        celular: novoFiltro.celular ? [novoFiltro.celular] : null,
        status: novoFiltro.status ? [novoFiltro.status] : null,
      });
      setSemFiltros(false);
    }

    if (pagina) {
      setCurrentPage(Number(pagina));
    }
  }, []);

  const onChange: TableProps<any>["onChange"] = (pagination, filters) => {
    setFilteredInfo({
      nomeParceiro: filters.nomeParceiro as string[] | null,
      nomeLeads: filters.nomeLeads as string[] | null,
      celular: filters.celular as string[] | null,
      status: filters.status as string[] | null,
    });

    const hasFilters = Boolean(
      filters.nomeParceiro ||
        filters.nomeLeads ||
        filters.celular ||
        filters.status
    );
    setSemFiltros(!hasFilters);

    if (pagination.current) {
      localStorage.setItem(
        "pageGerPropriedades",
        pagination.current.toString()
      );
    }

    localStorage.setItem("filtrosPropriedades", JSON.stringify(filters));
  };

  const removerFiltros = () => {
    localStorage.removeItem("filtrosPropriedades");
    localStorage.removeItem("pageGerPropriedades");

    setFilteredInfo({
      nomeParceiro: null,
      nomeLeads: null,
      celular: null,
      status: null,
    });
    setSemFiltros(true);
    setCurrentPage(1);
  };

  const handleFilter = () => {
    removerFiltros();
  };

  // OnClick das opções e funções que serão realizadas do item Ações
  const onClick: MenuProps["onClick"] = async ({ key }) => {
    switch (key) {
      // Excluir
      case "1":
        handleModalExcluir();
        break;
      // Excluir
      case "2":
        handleModalStatus();
        break;
    }
  };

  // Traz as informações  OnClick, origem , nome e id do apartamento além do nome do empreendimento, ao clickar na linha especifica
  const columns = Columns(onClick, setIndicacaoId, setIndicacaoStatus, {
    nomeParceiro: filteredInfo.nomeParceiro,
    nomeLeads: filteredInfo.nomeLeads,
    celular: filteredInfo.celular,
    status: filteredInfo.status,
  });

  // Adicionar Indicacão
  const [openModalAdicionar, setOpenModalAdicionar] = useState<boolean>(false);

  const handleModalAdicionar = () => {
    setOpenModalAdicionar(!openModalAdicionar);
  };

  // Desativar Indicacão
  const [openModalExcluir, setOpenModalExcluir] = useState<boolean>(false);

  const handleModalExcluir = () => {
    setOpenModalExcluir(!openModalExcluir);
  };

  // Alterar Status
  const [openModalStatus, setOpenModalStatus] = useState<boolean>(false);

  const handleModalStatus = () => {
    setOpenModalStatus(!openModalStatus);
  };

  return (
    <>
      {(isLoading && isTokenLoading) || !isValid ? (
        <Skeleton active />
      ) : (
        <>
          <Container>
            <Row>
              <Col span={5}>
                <Flex align="center" justify="center" style={{ marginTop: 15 }}>
                  <a href={`/inicio`}>
                   
                  </a>
                </Flex>
              </Col>
              <Col span={12}>
                <Flex align="center" justify="center">
                  <HomeIcon color="primary" fontSize="large" />
                  <Title
                    style={{
                      marginLeft: 10,
                      marginTop: 10,
                      fontSize: isMobile ? "1rem" : "2rem",
                      color: "rgb(0, 54, 68)",
                    }}
                    level={3}
                  >
                    Gerenciar Indicações
                  </Title>
                </Flex>
              </Col>
            </Row>

            <Row>
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                  height: "auto",
                  width: "90%",
                  gap: "20px",
                }}
              >
                <div style={{ display: "flex", gap: "20px" }}>
                  <Button
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "auto",
                    }}
                    onClick={handleModalAdicionar}
                    type="primary"
                  >
                    + Indicação Parceiro
                  </Button>

                  {semFiltros ? (
                    <Button onClick={handleFilter} type="primary" disabled>
                      <FilterAltIcon />
                    </Button>
                  ) : (
                    <Button onClick={handleFilter} type="primary">
                      <FilterAltOffIcon />
                    </Button>
                  )}
                </div>
              </div>
              <Col span={isMobile ? 5 : 1}></Col>

              <Col
                span={22}
                style={{
                  marginTop: isMobile ? 15 : 15,
                  marginBottom: isMobile ? 30 : 50,
                }}
              >
                <Flex
                  style={{
                    width: isMobile ? "auto" : "100%",
                    overflow: "auto",
                    marginLeft: 30,
                  }}
                >
                  <Table
                    rowKey="id"
                    columns={columns}
                    dataSource={indicacoesParceiros}
                    onChange={onChange}
                    bordered
                    style={{
                      alignItems: "center",
                      justifyContent: "center",
                      width: isMobile ? "auto" : "100%",
                      maxWidth: isMobile ? "none" : "100%",
                    }}
                    pagination={{ defaultCurrent: currentPage }}
                  />
                </Flex>
              </Col>

              <Col span={1}></Col>
            </Row>
          </Container>
          <ModalAdicionar
            isModalOpen={openModalAdicionar}
            handleFechar={handleModalAdicionar}
            indicacaoId={indicacaoId}
            buscar={buscar}
          />
          <ModalExcluir
            isModalOpen={openModalExcluir}
            handleFechar={handleModalExcluir}
            indicacaoId={indicacaoId}
            buscar={buscar}
          />
          <ModalStatus
            isModalOpen={openModalStatus}
            handleFechar={handleModalStatus}
            indicacaoId={indicacaoId!}
            indicacaoStatus={indicacaoStatus!}
            buscar={buscar}
          />
        </>
      )}
    </>
  );
}
